export default "__VITE_ASSET__DRgFlLU5__"